import React, { useState } from "react";
import { Grid, Typography, Button, makeStyles, CircularProgress } from "@material-ui/core";
import { CloudUpload as CloudUploadIcon, CheckCircle as CheckCircleIcon } from "@material-ui/icons";
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        textAlign: "center",
    },
    uploadArea: {
        border: "2px dashed #ccc",
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#f9f9f9",
        },
    },
    hiddenInput: {
        display: "none",
    },
    successArea: {
        padding: theme.spacing(2),
        backgroundColor: "#e8f5e9",
        borderRadius: theme.shape.borderRadius,
        marginTop: theme.spacing(2),
    },
}));

const CampaignImportStep = ({ campaign, onUploadSuccess }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [stats, setStats] = useState(null);

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        setFile(selectedFile);
        await uploadFile(selectedFile);
    };

    const uploadFile = async (fileToUpload) => {
        if (!campaign.id) {
            toast.error("Erro: Campanha não identificada. Volte e salve o passo anterior.");
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("file", fileToUpload);

        try {
            const { data } = await api.post(`/email-campaigns/${campaign.id}/import`, formData);
            setStats(data);
            onUploadSuccess(data);
            toast.success(`Importação concluída: ${data.valid} contatos válidos.`);
        } catch (err) {
            toast.error("Erro ao importar arquivo.");
            setFile(null);
        }
        setLoading(false);
    };

    return (
        <div className={classes.root}>
            <Typography variant="h6">Importar Contatos</Typography>
            <Typography variant="body2" color="textSecondary">
                Faça upload de um arquivo CSV com as colunas: <strong>nome, email, telefone (opcional)</strong>.
            </Typography>

            {!stats && !loading && (
                <>
                    <input
                        accept=".csv"
                        className={classes.hiddenInput}
                        id="raised-button-file"
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="raised-button-file">
                        <div className={classes.uploadArea}>
                            <CloudUploadIcon style={{ fontSize: 48, color: "#ccc" }} />
                            <Typography variant="h6" color="textSecondary">
                                Clique ou arraste o arquivo CSV aqui
                            </Typography>
                        </div>
                    </label>
                </>
            )}

            {loading && (
                <div className={classes.uploadArea}>
                    <CircularProgress />
                    <Typography variant="body1" style={{ marginTop: 10 }}>Processing CSV...</Typography>
                </div>
            )}

            {stats && (
                <div className={classes.successArea}>
                    <CheckCircleIcon style={{ color: "#4caf50", fontSize: 40 }} />
                    <Typography variant="h6" style={{ color: "#4caf50" }}>
                        Upload Concluído!
                    </Typography>
                    <Typography variant="body1">
                        Total processado: {stats.total}<br />
                        Contatos válidos: {stats.valid}<br />
                        Erros/Inválidos: {stats.invalid}
                    </Typography>
                    {stats.errors.length > 0 && (
                        <div style={{ textAlign: 'left', marginTop: 10, maxHeight: 100, overflowY: 'auto' }}>
                            <Typography variant="caption" color="error">Erros:</Typography>
                            <ul>
                                {stats.errors.slice(0, 10).map((err, idx) => (
                                    <li key={idx}><Typography variant="caption" color="error">{err}</Typography></li>
                                ))}
                                {stats.errors.length > 10 && <li>...</li>}
                            </ul>
                        </div>
                    )}
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => { setStats(null); setFile(null); }}
                        style={{ marginTop: 10 }}
                    >
                        Importar outro arquivo
                    </Button>
                </div>
            )}
        </div>
    );
};

export default CampaignImportStep;
